import { StyleSheet, View } from '@react-pdf/renderer';

import { Text } from '../../../components/PdfExportV2/Text/Text.tsx';
import { selectAllCommentaryData } from '../../../redux/features/selectors/commentarySelectors/selectAllCommentaryData.ts';
import { COMMENTARY_TEXT } from '../consts.ts';
import { ExportCommentarySubsection } from './ExportCommentarySubsection.tsx';
import { ExportCommentaryTable } from './ExportCommentaryTable.tsx';

const styles = StyleSheet.create({
  structureContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
});

type Data = Pick<ReturnType<typeof selectAllCommentaryData>, 'additionalStructures'>;

export const ExportAdditionalStructures = ({ data: { additionalStructures } }: { data: Data }) => (
  <ExportCommentarySubsection {...COMMENTARY_TEXT['dep-cost'].subItems.additionalStructures}>
    {additionalStructures.map((structure) => (
      <View key={structure.label} style={styles.structureContainer} wrap={false}>
        <Text variant="h3">{structure.label}</Text>
        <ExportCommentaryTable
          data={structure.tableData}
          configKey="additionalStructures"
          helperText={structure.helperText}
        />
      </View>
    ))}
  </ExportCommentarySubsection>
);
